import { useMemo } from "react";
import constants from "utils/constants";
import { createSatelliteUrlCss } from "utils/createSatelliteUrl";
import formatDollar from "utils/formatDollar";
import { usePropertyContext } from "../context";
import { useExemptionsContext } from "../ExemptionsContext";
import ExemptionsEstimateCardExpandSection from "./ExemptionsEstimateCardExpandSection";

const ExemptionsEstimateCard = ({ retro }: { retro?: boolean }) => {
	const { satelliteUrlCss } = usePropertyContext();
	const { futureSavingsAmount, retroSavingsAmount, flowId } =
		useExemptionsContext();

	return (
		<div id="exemptions-savings-box" className="appeal-savings-box-vertical">
			<div
				id="appeal-savings-box-left"
				className="appeal-savings-box-left-savings-page"
				style={{
					background: satelliteUrlCss,
				}}></div>
			<div id="appeal-savings-box-right">
				<div id={"savings-loading-container"}>
					{flowId === "GEORGIA_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								Average First Year Savings*
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_GA_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "CALIFORNIA_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								Average Five Year Savings*
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_CA_AVERAGE_FIVE_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "TEXAS_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								{retro && !!retroSavingsAmount
									? "Potential Refund"
									: "Average First Year Savings*"}
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_AVERAGE_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "NEW_YORK_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								{retro && !!retroSavingsAmount
									? "Potential Refund"
									: "Average First Year Savings*"}
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_NY_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "ILLINOIS_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								{retro && !!retroSavingsAmount
									? "Potential Refund"
									: "Average First Year Savings*"}
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_IL_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "FLORIDA_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								{retro && !!retroSavingsAmount
									? "Potential Refund"
									: "Average First Year Savings*"}
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_FL_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "MICHIGAN_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								{retro && !!retroSavingsAmount
									? "Potential Refund"
									: "Average First Year Savings*"}
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_MI_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
					{flowId === "PENNSYLVANIA_EXEMPTION" && (
						<>
							<p className="bold exemptions-estimate-card-savings-text">
								Average First Year Savings*
							</p>
							<h1 className="exemptions-estimate-card-saving-amt no-translate">
								{retro && !!retroSavingsAmount
									? formatDollar(retroSavingsAmount)
									: constants.EXEMPTIONS_PA_AVERAGE_FIRST_YEAR_SAVINGS}
							</h1>
						</>
					)}
				</div>
				{retro && !!retroSavingsAmount && (
					<>
						<div className="exemptions-estimate-card-future-yearly-savings-container">
							<p className="lg bold">+</p>
							<div className="exemptions-estimate-card-future-yearly-savings-flex">
								<p className="bold">Future Yearly Savings</p>
								<h1
									className="no-translate display2"
									style={{ fontWeight: 400 }}>
									{futureSavingsAmount
										? formatDollar(futureSavingsAmount)
										: constants.EXEMPTIONS_AVERAGE_SAVINGS}
								</h1>
							</div>
						</div>
						<ExemptionsEstimateCardExpandSection />
					</>
				)}
			</div>
		</div>
	);
};

export default ExemptionsEstimateCard;
